import React from "react";

type DotProps = {
  duration: number;
  interval: number;
  className?: string;
};

/**
 * Tečka indikující "freshness" hodnoty s fade animací.
 *
 * Klíčová informace, kterou tečka nese:
 *  - Počáteční opacity = `duration / interval` → poměr "jak nedávno přišla hodnota"
 *    (1 = právě teď, 0 = expected next už proběhlo)
 *  - Délka fade = `duration` ms → vizualizace času do očekávané další hodnoty
 *  - Když value přijde, prop se změní → unikátní keyframe name → animace se restartuje
 *
 * Runtime <style> s unikátním `@keyframes` per (duration, interval) je nutné, aby
 * browser viděl změnu animation name a restartoval animaci. Sdílený keyframe by
 * neumožnil restart při change props.
 */
export const Dot: React.FC<DotProps> = ({ duration, interval, className }) => {
  const animationName = `fade-opacity-${duration}-${interval}`;

  return (
    <>
      <span
        className={`font-semibold text-green-500 opacity-0 px-1 ${className ?? ""}`}
        style={{
          animationDuration: `${duration}ms`,
          animationTimingFunction: "linear",
          animationIterationCount: 1,
          animationName: animationName,
        }}
        aria-hidden
      >
        ●
      </span>
      <style>{`
        @keyframes ${animationName} {
          0% {
            opacity: ${interval > 0 ? duration / interval : 0};
          }
          100% {
            opacity: 0;
          }
        }
      `}</style>
    </>
  );
};

export default React.memo(Dot);
